



export default {
  state: {
    semiologiaView: null
  },
  mutations: {

    setSemiologiaView(state, newData){
      state.semiologiaView = { ...newData }
    },

    resetSemiologiaView(state){
      state.semiologiaView = null
    },
  },
  
}